import axios from 'axios'

import { fetchWrapper } from '../../reducers/fetch'
import { updateYourTurnCount } from './conversation.slice'

export const POST_CREATE_TICKET_KEY = 'POST_CREATE_TICKET_KEY'
export const postCreateNewTicket = (payload: {
  comment: {
    body: string
    htmlBody: string
  }
  subject: string
  topic?: string
  tags?: string[]
  // this is different than topic - topic assigns a ticket form on the BE, this is a custom field
  ticketTopic?: string
  ticketTask?: string
}) =>
  fetchWrapper({
    fetchKey: POST_CREATE_TICKET_KEY,
    fetchFunction: async () => {
      await axios.post('/finances/api/v1/conversations', {
        ...payload,
        internalSubmitter: true,
      })
    },
  })

export const fetchUnreadMessageCount = () =>
  fetchWrapper({
    fetchFunction: async (dispatch) => {
      const json = await axios.get<{ unreadMessageCount: number }>(
        '/finances/api/v1/zendesk/metadata'
      )

      dispatch(updateYourTurnCount(json.data.unreadMessageCount))
      return json.data
    },
    handleError: (dispatch) => dispatch(updateYourTurnCount(0)),
  })
